/**
 * Get keys from deep objects
 * @module
 */

var _ = require('optimizely-client-fn');

/**
 * Returns the value of field specified by keyPath in object.
 * @param {Object.<*>} obj
 * @param {KeyPath} keyPath Field key path.
 * @returns {*|undefined} Field value.
 */
exports.getFieldValue = function(obj:Record<string, any>, keyPath:KeyPath): any|undefined {
  if (!_.isArray(keyPath)) {
    keyPath = [keyPath as string];
  }

  var result = obj;
  for (var i = 0; i < keyPath.length; i++) {
    var key = keyPath[i];
    if (!_.isObject(result) || !result.hasOwnProperty(key)) {
      return;
    }
    result = result[key];
  }

  return result;
};

/**
 * Set the property at the given key path of the given object, creating
 * empty intermediary objects as necessary.
 *
 * @param {Object} obj
 *        The object in which to set value at the given keyPath (mutate in-place).
 * @param {KeyPath} keyPath
 * @param {*} value
 * @throws {Error}
 *        If keyPath is not a valid KeyPath.
 */
exports.setFieldValue = function setFieldValue(obj:any, keyPath:KeyPath, value:any) {
  if (__INVARIANT__) {
    require('core/utils/invariant').isType('KeyPath', keyPath);
  }

  if (!_.isArray(keyPath) || _.isEmpty(keyPath)) {
    throw new Error('Attempted to set an invalid key path: ' + keyPath);
  }

  var base = obj;

  for (var i = 0; i < keyPath.length - 1; i++) {
    var key = keyPath[i];
    if (!_.isObject(base[key])) {
      base[key] = {} as any;
    }

    base = base[key];
  }

  base[keyPath[keyPath.length - 1]] = value;
};

